export default __webpack_public_path__ + "static/media/3d-casual-life-laptop-and-charts.8537bcff.png";